import api from '../../api/index';
import detail from './news_detail';

export default {
  namespaced: true,
  modules   : {
    detail,
  },
  state: {
    modals: [
      {
        type  : 'suggest_news_modal',
        active: false,
      },
      {
        type  : 'add_comment_modal',
        active: false,
      },
      {
        type  : 'modal_comment_edit',
        active: false,
      },
    ],
    search_string : '',
    filter_by_date: {
      from: '',
      to  : '',
    },
    filter_category  : '',
    current_item_news: {},
    current_id       : '',
    type             : 'all',
    selected_number  : 10,
    tabs             : [
      {
        id       : 1,
        tab_title: 'Все',
        type     : 'all',
      },
      {
        id       : 2,
        tab_title: 'Новости',
        type     : 'news',
      },
      {
        id       : 4,
        tab_title: 'Маркетинговые акции',
        type     : 'actions',
      },
    ],
    tab_model    : 'all',
    selected_page: 1,
    news_pages   : 1,
    event_types  : [
      {text: 'Онлайн', name: 'online'},
      {text: 'Офлайн', name: 'offline'},
      {text: 'Офлайн с онлайн трансляцией', name: 'online_reg'},
    ],
    news: [],

  },
  getters: {
    suggest_news_modal: ({modals}) => modals.find((modal)=> modal.type == 'suggest_news_modal').active,
    add_comment_modal : ({modals}) => modals.find((modal)=> modal.type == 'add_comment_modal').active,
    modal_comment_edit: ({modals}) => modals.find((modal)=> modal.type == 'modal_comment_edit').active,
    user_id           : ({}, getters, rootState) => {
      return rootState.autorisation.user_id;
    },
    current_user: ({}, getters, rootstate) => {
      return rootstate.profile.user.user;
    },
    filter_by_date  : ({filter_by_date}) => filter_by_date,
    news_pages      : ({news_pages}) => news_pages,
    event_types     : ({event_types}) => event_types,
    modal           : ({modal}) => modal,
    search_string   : ({search_string}) => search_string,
    tabs            : ({tabs}) => tabs,
    tab_model       : ({tab_model}) => tab_model,
    selected_page   : ({selected_page}) => selected_page,
    type            : ({type}) => type,
    filter_category : ({filter_category}) => filter_category,
    news            : ({news}) => news,
    selected_number : ({selected_number}) => selected_number,
    search_by_string: ({news=[], search_string, type})=> {
      let news_typed = news.filter((y) => y.type == type);
      if (search_string) {
        if (type === 'all') {
          return news.filter((x)=> x.title.toLowerCase().includes(search_string.toLowerCase()));
        } else {
          return news_typed.filter((x) => x.title.toLowerCase().includes(search_string.toLowerCase()));
        }
      } else if (type === 'all') {
        return news;
      } else {
        return news_typed;
      }
    },
    filtered_by_date: ({filter_category, tab_model}, {filter_by_date, search_by_string}) => {
      // const date_to = new Date().setDate(new Date(filter_by_date.to).getDate());
      let ar_date = [];
      let news_types = [];
      // если выбрана категория мероприятия
      if (tab_model=='events' && filter_category) {
        news_types = search_by_string.filter((item)=>item.event_type==filter_category);
      } else {
        news_types = search_by_string;
      }
      // если фильтруешь по дате
      if (filter_by_date.from || filter_by_date.to) {
        ar_date = news_types.filter((x) => (x.date >= filter_by_date.from && x.date <= filter_by_date.to));
        return ar_date;
      } else {
        return news_types;
      }
    },
    current_id       : ({current_id}) => current_id,
    current_item_news: ({current_item_news}) => current_item_news,
    form_registration: ({}, getters, rootState) => {
      return rootState.registration_event.form.user_id;
    },
  },
  mutations: {
    CLOSE_MODAL(state, type) {
      let modal = state.modals.find((modal)=> modal.type === type);
      modal.active = false;
    },
    OPEN_MODAL(state, type) {
      let modal = state.modals.find((modal)=> modal.type === type);
      if (!modal.active) {
        modal.active = true;
      }
    },
    SET_PAGES_COUNT(state, value) {
      state.news_pages = value;
    },
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    SET_FILTER_DATES(state, obj) {
      const {value, period} = obj;
      if (period =='from') {
        state.filter_by_date.from = value;
      } else {
        state.filter_by_date.to = value;
      }
    },
    RESET_FILTER(state) {
      state.filter_by_date.from = '';
      state.filter_by_date.to = '';
      state.filter_category = '';
    },
    SET_NEWS_TYPE(state, value) {
      state.type = value;
    },
    SET_NEWS_COUNT(state, obj) {
      const {array, selected} = obj;
      state.selected_page = 1;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    SEARCH_STRING(state, value) {
      state.search_string = value;
    },
    FILTER_CATEGORY(state, value) {
      state.filter_category = value;
    },
    SET_CURRENT_ID(state, id) {
      state.current_id = id;
      state.current_item_news = state.news.filter((x )=> x.id == id)[0];
    },
    SET_TAB(state, value) {
      state.tab_model = value;
    },
    SET_NEWS(state, value) {
      state.news = value.content;
      state.news.forEach((x)=> {
        if (typeof x.date!= 'object') {
          x.date = x.date*1000;
        } else {
          x.forEach((y)=>y.date = y.date*1000);
        }
      });
    },
    TO_LIKED(state, id) {
      let current_news = state.news.find((item)=>item.id == id);
      if (current_news) {
        current_news.liked = !current_news.liked;
        if (current_news.liked) {
          current_news.likes = parseInt(current_news.likes, 10) + 1;
        } else {
          current_news.likes = parseInt(current_news.likes, 10) - 1;
        }
      }
    },
    TOGGLE_NEWS_FAVOURITE(state, id) {
      // let current_idx = state.news.findIndex((item)=>item.id == id);
      let current_item = state.news.find((item)=>item.id == id);
      current_item.favourite = current_item && current_item.favourite;
    },
  },
  actions: {
    async get_news({commit, getters}) {
      let {tab_model, filter_by_date, search_string, selected_page, selected_number} = getters;
      let tab_selected = tab_model == 'all' ? '' : tab_model;
      try {
        const news = await api.events.get_events(tab_selected, filter_by_date.to || new Date().getTime(), filter_by_date.from || 0, selected_page, selected_number, search_string);
        commit('SET_NEWS', news.data);
        commit('SET_PAGES_COUNT', news.data.page_count);
      } catch (err) {
        console.error(err);
      }
    },
    async get_news_detail({commit}, id) {
      try {
        const news = await api.events.get_event_by_id(id);
        commit('SET_NEWS_DETAIL', news.data);
      } catch (err) {
        console.error(err);
      }
    },
    send_suggestion({commit, dispatch}, event) {
      dispatch('post_suggestion', event);
      commit('CLOSE_MODAL', 'suggest_news_modal');
    },
    async post_suggestion({}, new_event) {
      try {
        let suggest = await api.events.post_event(new_event);
        return suggest;
      } catch (err) {
        console.error(err);
      }
    },
    event_category({state, commit}, event) {
      const filter = state.event_types.find((item)=>item.text==event);
      if (filter) {
        commit('FILTER_CATEGORY', filter.name);
      }
    },
    async like_news({state, commit, rootGetters}, id) {
      let likedNews = state.news.find((item) => item.id == id);
      let likedDetail = rootGetters['news_main/detail/news_content'];
      if (likedNews) {
        commit('TO_LIKED', id);
      }
      if (likedDetail.type) {
        commit('news_main/detail/TO_LIKED_DETAIL', id, {root: true});
      }
      if (likedNews.liked || likedDetail.liked) {
        try {
          await api.events.like_event(likedNews.id);
        } catch (err) {
          console.error(err);
        }
      } else {
        try {
          await api.events.unlike_event(likedNews.id);
        } catch (err) {
          console.error(err);
        }
      }
    },
  },

};
